import { Link } from 'react-router-dom';
import { stats } from '@/mocks/siteData';

export default function ContentHub() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-14 lg:gap-20">
          <div className="flex-1">
            <article>
              <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-tight">
                What Is a Superbuy Spreadsheet and Why Every Smart Shopper Needs One
              </h2>
              <div className="mt-6 space-y-4 text-base text-foreground-600 leading-relaxed">
                <p>
                  A <strong className="text-foreground-900">Superbuy Spreadsheet</strong> is more than just a product list — it&apos;s a complete sourcing system that organizes thousands of items across 14 curated categories including <strong className="text-foreground-900">Shoes</strong>, <strong className="text-foreground-900">Hoodies/Sweaters</strong>, <strong className="text-foreground-900">T-Shirts</strong>, and <strong className="text-foreground-900">Accessories</strong>. Instead of spending hours scrolling through endless listings, you get a clean, organized view of the best products with pricing, seller ratings, and direct purchase links all in one place.
                </p>
                <p>
                  Whether you&apos;re sourcing <strong className="text-foreground-900">Nike Dunks</strong>, <strong className="text-foreground-900">Essentials Hoodies</strong>, or <strong className="text-foreground-900">designer accessories</strong>, the Superbuy Spreadsheet cuts your browsing time by 80% and helps you make smarter buying decisions. With curated collections updated regularly, you always have access to the latest and most popular items across every category.
                </p>
                <p>
                  The spreadsheet system categorizes products by brand, price range, and popularity — making it the ultimate tool for international shoppers who want to navigate the global market efficiently. From <strong className="text-foreground-900">Shoes</strong> to <strong className="text-foreground-900">Perfumes</strong>, everything is just a click away on your <Link to="/" className="text-primary-500 hover:text-primary-600 underline underline-offset-2 transition-colors">Superbuy Spreadsheet homepage</Link>.
                </p>
              </div>
            </article>

            <Link
              to="/article/superbuy-sheet-beginner-guide"
              className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-accent-100 text-accent-900 rounded-full text-sm font-semibold hover:bg-accent-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              Read Full SEO Guide
              <i className="ri-arrow-right-line"></i>
            </Link>

            <div className="mt-12 flex flex-wrap gap-12">
              {stats.map((stat) => (
                <div key={stat.label}>
                  <div className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">{stat.value}</div>
                  <div className="text-sm text-foreground-400 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5] max-w-md mx-auto lg:max-w-none">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20still%20life%20arrangement%20of%20premium%20sneakers%20resting%20on%20a%20stack%20of%20cream%20colored%20coffee%20table%20books%20with%20a%20delicate%20dried%20pampas%20grass%20in%20a%20ceramic%20vase%2C%20soft%20afternoon%20sunlight%20casting%20gentle%20shadows%20on%20a%20light%20linen%20surface%2C%20warm%20neutral%20background%2C%20sophisticated%20home%20decor%20editorial%20style%2C%20elegant%20minimal%20interior%2C%20refined%20cozy%20atmosphere%2C%20muted%20earthy%20tones&width=800&height=900&seq=content-hub-v2&orientation=portrait"
                alt="Superbuy Spreadsheet product display with designer sneakers and accessories"
                title="Superbuy Spreadsheet curated collection display"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-4 left-4">
                <span className="px-4 py-2 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-semibold text-foreground-700">
                  Superbuy Spreadsheet
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-900/70 to-transparent p-6">
                <p className="font-heading text-xl text-background-50 font-semibold">Superbuy Spreadsheet</p>
                <p className="text-sm text-background-50/70 mt-1">Shop Global, Ship Easy</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}